import { IRequestSender } from '@studyportals/mb-platform-http-requests';
import { SuperAgentRequest, Response } from 'superagent';
import { PlatformIntegration } from '@/platform/PlatformIntegration';
import { IPlatformUiDisposable } from '@studyportals/external-editor-platform';

export class RequestSenderDecoratorUiLoader implements IRequestSender {
	private readonly target: IRequestSender;

	private readonly delayMs: number = 100;

	public constructor(target: IRequestSender) {
		this.target = target;
	}

	public async send(request: SuperAgentRequest): Promise<Response> {
		const loader = PlatformIntegration.instance.ui.loaderShow();

		try {
			return await this.target.send(request);
		} finally {
			this.delayedDispose(loader);
		}
	}

	public async sendAndExtractBody<T>(request: SuperAgentRequest): Promise<T> {
		const loader = PlatformIntegration.instance.ui.loaderShow();

		try {
			return await this.target.sendAndExtractBody<T>(request);
		} finally {
			this.delayedDispose(loader);
		}
	}

	private delayedDispose(loader: IPlatformUiDisposable): void {
		setTimeout(() => loader.dispose(), this.delayMs);
	}
}
